(function () {
  function pad(n) {
    return String(n).length < 2 ? '0' + n : String(n);
  }

  function initClock(root) {
    var launch = root.getAttribute('data-kg-launch');
    var petitionUrl = root.getAttribute('data-kg-petition-url') || '#';
    if (!launch) return;

    var target = new Date(launch).getTime();
    if (Number.isNaN(target)) return;

    var els = {
      dd: root.querySelector('[data-kg-unit="dd"]'),
      hh: root.querySelector('[data-kg-unit="hh"]'),
      mm: root.querySelector('[data-kg-unit="mm"]'),
      ss: root.querySelector('[data-kg-unit="ss"]')
    };
    var opens = root.querySelector('[data-kg-opens]');
    var petition = root.querySelector('[data-kg-petition]');

    if (petition) petition.setAttribute('href', petitionUrl);

    if (opens) {
      opens.textContent =
        (opens.getAttribute('data-kg-opens-prefix') || 'The petition opens ') +
        new Date(target).toLocaleDateString('en-US', {
          month: 'long',
          day: 'numeric',
          year: 'numeric'
        });
    }

    function tick() {
      var left = Math.max(0, target - Date.now());
      if (els.dd) els.dd.textContent = pad(Math.floor(left / 86400000));
      if (els.hh) els.hh.textContent = pad(Math.floor(left / 3600000) % 24);
      if (els.mm) els.mm.textContent = pad(Math.floor(left / 60000) % 60);
      if (els.ss) els.ss.textContent = pad(Math.floor(left / 1000) % 60);
      if (left <= 0) root.classList.add('is-open');
    }

    tick();
    setInterval(tick, 1000);
  }

  function boot() {
    document.querySelectorAll('[data-kg-hero]').forEach(initClock);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
